import { GenericLazyString } from '@eventbrite/i18n';
import { GA_APPLE, TOSMODAL_SOCIAL_ACCEPTED } from '../constants/analytics';
import { LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT } from '../constants/apiErrors';
import { IAllContextsProps } from '../constants/interfaces';
import { trackToSAction } from '../tracking/tos';
import { handleAppleSocialLogin } from './appleHandlers';
import { handleSocialLogIn } from './social';

export const handleCancelToS = ({
    action,
    notificationMessage,
    trackLabel = null,
    contexts,
    routing,
}: {
    action: string;
    notificationMessage: GenericLazyString;
    trackLabel?: string | null;
    contexts: IAllContextsProps;
    routing?: any;
}) => {
    trackToSAction({ action, trackLabel, contexts, routing });

    contexts.notificationsContext?.methods.setGeneralNotification({
        message: notificationMessage,
    });

    contexts.frontendContext?.methods.setShowToSDialog(false);

    contexts.userContext?.methods.setSocialData({});

    contexts.configContext?.tosMethods?.declineToS?.();
};

export const handleAcceptToS = ({
    formData,
    action,
    contexts,
    trackLabel = null,
    routing,
    onAccept,
}: {
    action: string;
    formData: any;
    trackLabel?: string | null;
    contexts: IAllContextsProps;
    routing?: any;
    onAccept: (formData: any) => void;
}) => {
    trackToSAction({ action, trackLabel, contexts, routing });

    contexts.notificationsContext?.methods.setGeneralNotification({});

    contexts.frontendContext?.methods.setShowToSDialog(false);

    contexts.userContext?.methods.setTosSocialAccepted(true);

    contexts.configContext?.tosMethods?.acceptToS?.(formData);

    onAccept(formData);
};

export const handleAcceptSocialToS = ({
    contexts,
    routing,
}: {
    contexts: IAllContextsProps;
    routing?: any;
}) => {
    const socialProvider = contexts.userContext?.state.socialProvider ?? '';
    const socialData = contexts.userContext?.state.socialData;
    const tosSocialStatus = contexts.userContext?.state.tosSocialStatus;

    trackToSAction({
        action: TOSMODAL_SOCIAL_ACCEPTED,
        trackLabel: socialProvider,
        contexts,
        routing,
    });

    contexts.notificationsContext?.methods.setGeneralNotification({});

    contexts.frontendContext?.methods.setShowToSDialog(false);

    contexts.userContext?.methods.setTosSocialAccepted(true);

    contexts.configContext?.tosMethods?.acceptSocialToS?.();

    if (socialProvider === GA_APPLE) {
        if (tosSocialStatus === LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT) {
            handleAppleSocialLogin({
                data: socialData[socialProvider],
                isSoftAccount: true,
                contexts,
            });
        }
    } else {
        handleSocialLogIn({
            data: socialData[socialProvider],
            socialProvider,
            contexts,
        });
    }
};

export const handleShowToS = ({
    action,
    trackLabel = null,
    contexts,
    routing,
}: {
    action: string;
    trackLabel?: string | null;
    contexts: IAllContextsProps;
    routing?: any;
}) => {
    trackToSAction({ action, trackLabel, contexts, routing });

    contexts.notificationsContext?.methods.setGeneralNotification({});

    contexts.frontendContext?.methods.setShowToSDialog(true);

    contexts.userContext?.methods.setTosSocialAccepted(false);

    contexts.configContext?.tosMethods?.showToS?.();
};
